/// <amd-module name="Build/Common/Artifacts/providers/ArtifactProvider" />
import { IVssService, Services, VssService, IVssPageContext } from "VSS/Platform/Context";
import { IArtifactProvider, BuildArtifactTypes, ArtifactProviderContext } from 'Common';
import { Container } from 'providers/Container';
import { PipelineArtifact } from 'providers/PipelineArtifact';
import { FilePath } from 'providers/Filepath';
import { GitRef } from 'providers/GitRef';
import { TfvcLabel } from 'providers/TfvcLabel';
import { VersionControl } from 'providers/VersionControl';
import { SymbolRequest } from 'providers/SymbolRequest';
import { SymbolStore } from 'providers/SymbolStore';
import { Unknown } from 'providers/Unknown';
import { BuildArtifact } from 'Build/Client/Contracts/Build';

export interface IArtifactProviderService extends IVssService {
    getArtifactProvider(artifact: BuildArtifact, context: ArtifactProviderContext): IArtifactProvider;
}

export class ArtifactProviderService extends VssService implements IArtifactProviderService {
    public getArtifactProvider(artifact: BuildArtifact, context: ArtifactProviderContext): IArtifactProvider {
        const artifactType = artifact.resource.type.toLowerCase();
        switch (artifactType) {
            case BuildArtifactTypes.Container:
                return new Container(this.pageContext, artifact, context);
            case BuildArtifactTypes.PipelineArtifact:
                return new PipelineArtifact(this.pageContext, artifact, context);
            case BuildArtifactTypes.FilePath:
                return new FilePath(this.pageContext, artifact, context);
            case BuildArtifactTypes.GitRef:
                return new GitRef(this.pageContext, artifact, context);
            case BuildArtifactTypes.TfvcLabel:
                return new TfvcLabel(this.pageContext, artifact, context);
            case BuildArtifactTypes.VersionControl:
                return new VersionControl(this.pageContext, artifact, context);
            case BuildArtifactTypes.SymbolRequest:
                return new SymbolRequest(this.pageContext, artifact, context);
            case BuildArtifactTypes.SymbolStore:
                return new SymbolStore(this.pageContext, artifact, context);
            default:
                return new Unknown(this.pageContext, artifact, context);
        }
    }
}

Services.add("IArtifactProviderService", { serviceFactory: ArtifactProviderService });
